import React from 'react';
import { useOutlet } from 'react-router-dom';
import { Header, Footer, Suspension } from '@/components'

import './BaseLayout.less';

export default () => {
  const outlet = useOutlet();
  return <div className="baseLayout">
    <Header />
    <div className='baseContainer'>
      {outlet}
    </div>
    <Suspension />
    <Footer />
  </div>
}